import '@/lib/fonts';
import '@/styles/tokens.css';
import { must } from '@/lib/dom';
import { state } from '@/store/state';
import { isMobile } from '@/config';
import { pool } from '@/engine/pool';
import { startReviver } from '@/engine/revive';
import { initGrid, renderWall, applyFit, removeFromWall } from '@/ui/grid';
import { initPanel } from '@/ui/panel';
import { initSpotlight, openSpotlight } from '@/ui/spotlight';
import { initKiosk } from '@/ui/kiosk';
import { initToolbar, syncControls, updateTele } from '@/ui/toolbar';
import { startClock } from '@/ui/clock';
import * as bus from '@/lib/bus';

function buildShell(): void {
  const app = must('#app');
  app.className = 'app';
  app.innerHTML = `
    <header class="bar" id="toolbar"></header>
    <div class="wrap">
      <aside class="panel" id="panel"></aside>
      <div class="backdrop" id="backdrop"></div>
      <main class="stage" id="stage">
        <div class="grid" id="grid" data-l="fit"></div>
        <div class="empty" id="empty"><div class="et">ยังไม่มีกล้องบนวอลล์</div><div class="es">เลือกกล้องจากแผงด้านซ้าย</div></div>
        <section class="spotlight" id="spotlight"></section>
      </main>
    </div>
    <div class="kiosk-bar" id="kioskBar"></div>
    <div class="kiosk-clock mono" id="kioskClock"></div>
    <div class="toasts" id="toasts"></div>`;
}

function boot(): void {
  buildShell();

  // engine + ui
  initGrid();
  initPanel();
  initSpotlight();
  initKiosk();
  initToolbar();

  // cross-module actions
  bus.on('spotlight', (id) => openSpotlight(id));
  bus.on('wall:remove', (id) => removeFromWall(id));

  // initial view state
  document.documentElement.style.setProperty('--gap', state.gutter === 'comfy' ? '8px' : '6px');
  const app = must('#app');
  if (!state.panelOpen && !isMobile()) app.classList.add('panel-closed');
  must('#backdrop').addEventListener('click', () => app.classList.remove('drawer-open'));

  renderWall();
  syncControls();
  startClock();

  // per-second: playback watchdog + telemetry
  window.setInterval(() => {
    for (const t of pool.attached) t.tick();
    updateTele();
  }, 1000);

  // re-test cameras the "online only" filter is hiding, so they come back by
  // themselves once they recover
  startReviver();

  window.addEventListener('resize', () => {
    pool.refreshMax();
    applyFit();
    syncControls();
  });
}

boot();
